import { Outlet } from "react-router-dom";

/**
 * Admin shell. The section nav (Overview / Customers / Status alerts / Forms /
 * Knowledge base / iQuest staff / View as user) expands inline under "Admin" in
 * the main sidebar (see config/nav.ts), so this is just the parent route
 * element that renders the active section.
 */
export function AdminLayout() {
  return <Outlet />;
}
